import { useCallback } from 'react';
import {
  COOKIE_CONSENT,
  TAnalyticsTrackEvent,
  TAnalyticsTrackPage
} from '../constant';
import { initialiseController, trackByEvent, trackByPage } from '../services';
import { CookieConsent } from '@takeaway/ui-vanilla';
import { useAnalyticsContainer } from '../components/AnalyticsContainer';


export type TAnalyticsHook = () => {
  trackPage: TAnalyticsTrackPage;
  trackEvent: TAnalyticsTrackEvent;
  initialise: () => void;
  getConsentData: () => COOKIE_CONSENT;
};

export const useAnalyticsHook: TAnalyticsHook = () => {
  const getContainerState = useAnalyticsContainer();

  const trackEvent = useCallback(
    (event, data) => {
      if (getContainerState) {
        trackByEvent(event, data);
      }
    },
    [getContainerState]
  );

  const trackPage = useCallback(
    (page, data) => {
      if (getContainerState) {
        trackByPage(page, data);
      }
    },
    [getContainerState]
  );

  const getConsentData = () => {
    return CookieConsent.getConsent() as COOKIE_CONSENT;
  };

  const initialise = useCallback(() => {
    if (getContainerState) {
      initialiseController();
    }
  }, [getContainerState]);

  return { trackPage, initialise, trackEvent, getConsentData };
};
